export default class AcordeonComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.prepararConfiguracion();
        this.prepararLigasTitulos();
    }

    prepararConfiguracion() {
        this.multiple = this.hasAttribute("multiple");
        this.colapsarContenido = this.tituloClickCallback();
        this.navegarTitulos = this.navegacionTitulosCallback();
        this.controlarContenido = this.controlContenidoCallback();
    }

    prepararLigasTitulos() {
        this.ligasTitulo = Array.from(this.querySelectorAll("& > :is(h1, h2, h3, h4, h5, h6) a[data-acordeon-target='titulo']"));
        const hash = window.location.hash.substring(1),
                contenidos = this.querySelectorAll("& > [data-acordeon-target='contenido']");
        let tituloId,
                contenidoId,
                contenidoElement,
                tituloActivo = false;

        for (const liga of this.ligasTitulo) {
            tituloId = liga.parentElement.getAttribute("id"),
            contenidoId = `${tituloId}-contenido`;
            contenidoElement = liga.parentElement.nextElementSibling,
            liga.setAttribute("aria-expanded", hash === tituloId);
            contenidoElement.setAttribute("id", contenidoId);
            liga.setAttribute("aria-controls", contenidoId);
            liga.addEventListener("click", this.colapsarContenido);
            liga.addEventListener("keydown", this.navegarTitulos);
            if (hash === tituloId) {
                tituloActivo = true;
                liga.tabIndex = 0;
            } else {
                liga.tabIndex = -1;
            }
        }

        for (const contenido of contenidos) {
            contenido.addEventListener("keydown", this.controlarContenido);
        }

        if (!tituloActivo) {
            this.ligasTitulo[0].tabIndex = 0;
        }
    }

    tituloClickCallback() {
        return (event) => {
            event.preventDefault();
            const { currentTarget } = event,
            contenidoActivo = this.querySelector("& > :has([data-acordeon-target='titulo'][aria-expanded='true']) + [data-acordeon-target='contenido']"),
                    tituloActivo = contenidoActivo?.previousElementSibling.firstElementChild,
                    contenidoTarget = currentTarget.parentElement.nextElementSibling,
                    isOpen = currentTarget.getAttribute("aria-expanded");

            if (!this.multiple && !!tituloActivo && tituloActivo !== currentTarget) {
                tituloActivo.setAttribute("aria-expanded", "false");
            }

            currentTarget.setAttribute("aria-expanded", isOpen === "true" ? "false" : "true");
            if(isOpen === "false") {
              currentTarget.scrollIntoView();
            }
        };
    }

    navegacionTitulosCallback() {
        return (event) => {
            const {key, currentTarget} = event,
            indiceActivo = this.ligasTitulo.findIndex(liga => liga.tabIndex === 0),
                    cantidadTitulos = this.ligasTitulo.length;
            let nuevoIndice,
                    tituloActivo;

            switch (key) {
                case "ArrowDown":
                    event.preventDefault();
                    nuevoIndice = (indiceActivo + 1) % cantidadTitulos;
                    tituloActivo = this.ligasTitulo[nuevoIndice];
                    currentTarget.tabIndex = -1;
                    tituloActivo.tabIndex = 0;
                    currentTarget.blur();
                    tituloActivo.focus();
                    break
                case "ArrowUp":
                    event.preventDefault();
                    nuevoIndice = (indiceActivo - 1 + cantidadTitulos) % cantidadTitulos;
                    tituloActivo = this.ligasTitulo[nuevoIndice];
                    currentTarget.tabIndex = -1;
                    tituloActivo.tabIndex = 0;
                    currentTarget.blur();
                    tituloActivo.focus();
                    break
                default:
                    return;
            }

            return true;
        };
    }

    controlContenidoCallback() {
        return (event) => {
            const {key, currentTarget} = event,
            tituloActivo = this.ligasTitulo.find(liga => liga.tabIndex === 0);

            switch (key) {
                case "Escape":
                    event.preventDefault();
                    document.activeElement.blur();
                    tituloActivo.focus();
                default:
                    return;
            }

            return true;
        };
    }
}
